import { trpc } from '@/trpc/client';

export function DebugPage(): JSX.Element {
  const utils = trpc.useUtils();
  const { data, isLoading } = trpc.debug.get.useQuery();
  const setAppendPrompt = trpc.debug.setAppendPrompt.useMutation({
    onSuccess: async () => {
      await utils.debug.get.invalidate();
    },
  });

  if (isLoading) return <p>読み込み中...</p>;
  const appendPrompt = data?.appendPrompt === true;

  return (
    <div className="max-w-2xl">
      <h1 className="mb-4 text-lg font-semibold">デバッグ設定</h1>
      <p className="mb-4 rounded bg-yellow-50 p-3 text-sm text-yellow-800">
        ⚠️ dev 環境でのみ有効です。本番環境では設定値に関わらずプロンプトは表示されません (Lambda が
        STAGE をチェック)。設定の反映には最大 60 秒かかります (Worker キャッシュ)。
      </p>

      <section className="mb-6 rounded border border-gray-200 p-4">
        <h2 className="mb-2 text-base font-semibold">応答末尾にプロンプトを表示</h2>
        <p className="mb-3 text-sm text-gray-600">
          ON にすると、AI fallback の応答メッセージに続けて、Gemini に送った最終プロンプトと matched
          カテゴリを 2 通目として送信します。
          カテゴリ分類やプロンプト設定が意図通りか確認するためのデバッグ機能です。
        </p>
        <div className="flex items-center gap-3">
          <button
            type="button"
            className={`rounded px-4 py-2 text-sm font-medium ${
              appendPrompt
                ? 'bg-green-600 text-white hover:bg-green-700'
                : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
            } disabled:opacity-50`}
            disabled={setAppendPrompt.isPending}
            onClick={() => setAppendPrompt.mutate({ value: !appendPrompt })}
          >
            {appendPrompt ? '🟢 ON' : '⚪ OFF'}
          </button>
          <span className="text-sm text-gray-600">クリックで切り替え</span>
        </div>
        {data?.updatedAt && (
          <p className="mt-3 text-xs text-gray-500">
            最終更新: {data.updatedAt} by {data.updatedBy?.email ?? '—'}
          </p>
        )}
      </section>
    </div>
  );
}
